<template>
  <Popover :class="height">
    <Float auto-placement portal :offset="10">
      <PopoverButton class="outline-0">
        <MaterialResourceAvatar
          :material-resource-id="materialResourceId"
          :role="role"
          :size="size"
          :blink-icon-enabled="blinkIconEnabled"
          :hide-status="hideStatus"
          :ring-color="ringColor"
          :border-color="borderColor"
          :shadow-color="shadowColor"
          :disponibility="disponibility"
        />
      </PopoverButton>
      <PopoverPanel
        v-slot="{ close }"
        class="z-10 w-screen max-w-sm px-4 sm:px-0 lg:w-72"
      >
        <div
          class="flex flex-col divide-y divide-slate-200 rounded-md border bg-white text-left shadow-2xl"
        >
          <div class="px-4 pb-3 pt-2">
            <h3 class="text-xl font-semibold text-slate-800">
              {{ material_resource.name[$i18n.locale] }}
            </h3>
          </div>
          <div v-if="$slots.panel" class="px-4 py-3">
            <slot
              name="panel"
              :close="close"
              :material-resource-id="materialResourceId"
            ></slot>
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import MaterialResourceAvatar from '@c/Avatar/MaterialResourceAvatar.vue'

export default {
  name: 'MaterialResourceAvatarPopover',
  components: {
    MaterialResourceAvatar,
    Float,
    PopoverPanel,
    PopoverButton,
    Popover
  },
  props: {
    materialResourceId: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: [String, Number],
      required: false,
      default: 9
    },
    badge: {
      type: Boolean,
      required: false,
      default: false
    },
    displayStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    hideStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    blinkIconEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    blinkIcon: {
      type: Array,
      required: false,
      default: () => ['fal', 'times']
    },
    borderColor: {
      type: String,
      required: false,
      default: null
    },
    ringColor: {
      type: String,
      required: false,
      default: null
    },
    shadowColor: {
      type: String,
      required: false,
      default: null
    },
    disponibility: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      contactAvailable: [
        'toast',
        'database',
        'sms',
        // 'mail',
        'slack'
      ],
      isComposeDialogOpen: false,
      composeType: null
    }
  },
  computed: {
    ...mapGetters({
      getMaterialResource: 'metadata/getMaterialResourceMetadata'
    }),
    height() {
      switch (this.size) {
        case 'extra-small':
          return 'h-6'
        case 'small':
          return 'h-8'
        case 'large':
          return 'h-10'
        case 'extra-large':
          return 'h-12'
        default:
          return 'h-9'
      }
    },
    material_resource() {
      return this.getMaterialResource(this.materialResourceId)
    }
  }
}
</script>
